module.exports = __webpack_public_path__ + "img/3_3.e934263c.png";